import { forwardRef } from 'react';

import { THeaderProps } from '..';
import { Add } from '@mui/icons-material';
import { Box, Button, Grid, Paper, PaperProps, Stack } from '@mui/material';
import Scrollbars from 'react-custom-scrollbars-2';

import { useScrollPercentage } from 'shared/hooks';
import { CustomScrollbar } from 'shared/ui/custom-scrollbar';

interface IProps extends PaperProps {
  headerProps?: THeaderProps;
  isFooter?: boolean;
  maxHeight?: number;
  children?: React.ReactNode;
}

export const CustomListbox = forwardRef<HTMLDivElement, IProps>(
  ({ headerProps, isFooter, maxHeight, ...props }, ref) => {
    const { handleScroll, scrollbarRef, contentRef, isShowScroll, ...customScrollProps } =
      useScrollPercentage();
    const childrenArray = new Array(props.children);

    return (
      <Paper
        {...props}
        role='listbox'
        sx={{
          padding: '0 !important',
          border: '1px solid var(--mui-palette-primary-main) !important',
          scrollbarWidth: 'none'
        }}
        elevation={0}>
        {!!headerProps && (
          <Grid
            container
            sx={{
              padding: '4px 16px',
              borderBottom: '1px solid rgba(24, 90, 194, 0.08)',
              gap: '10px'
            }}
            justifyContent='space-between'>
            <Button
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                px: '0',
                fontSize: '16px',
                '&:hover': { backgroundColor: 'unset' }
              }}
              endIcon={
                <Add
                  sx={{
                    color: 'currentColor',
                    '&:hover': { color: 'var(--mui-palette-methodsList-colorHover)' },
                    '&:active': { color: 'var(--mui-palette-methodsList-colorActive)' }
                  }}
                />
              }
              onClick={headerProps.onClick}>
              {headerProps.label}
            </Button>
          </Grid>
        )}
        <Scrollbars
          ref={scrollbarRef}
          style={{
            width: '100%',
            borderRadius: '16px',
            height: '100%',
            scrollbarColor: 'transparent transparent',
            scrollbarWidth: 'none'
          }}
          autoHeight
          renderTrackVertical={undefined}
          renderThumbVertical={undefined}
          onScroll={handleScroll}>
          <Box ref={contentRef}>{props.children}</Box>
        </Scrollbars>

        {isFooter && (
          <Stack
            direction={'row'}
            justifyContent='space-between'
            sx={{
              padding: '10px 16px',
              gap: '10px'
            }}>
            <Button
              sx={{
                padding: 0,
                color: 'var(--mui-palette-text-modalDark)',
                fontDamily: 'Roboto',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '600',
                lineHeight: '20px',
                letterSpacing: '0.04px'
              }}>
              Cancel
            </Button>
            <Button
              sx={{
                padding: 0,
                color: 'var(mui-palette-primary-main)',
                fontDamily: 'Roboto',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '600',
                lineHeight: '20px',
                letterSpacing: '0.04px'
              }}>
              Ok
            </Button>
          </Stack>
        )}
        {isShowScroll && (
          <CustomScrollbar
            customScrollProps={customScrollProps}
            sxScroll={{
              width: '8px',
              height: '95%',
              background: 'var(--mui-palette-customScrollbar-track)',
              position: 'absolute',
              top: '10px',
              right: '5px',
              borderRadius: '10px'
            }}
            sxThumb={{
              width: '100%',
              background: 'var(--mui-palette-customScrollbar-thumb)',
              borderRadius: '10px',
              position: 'absolute',
              cursor: 'pointer',
              top: '0'
            }}
          />
        )}
      </Paper>
    );
  }
);
